import mixpanel from "mixpanel-browser";

mixpanel.init("cf76fdfd967b2b2d94836ec43df3c1a8", {
  track_pageview: true,
  persistence: "localStorage",
});

export default mixpanel;
